import unitsData from './shared/state';

export default {
  modules: {
    unitsData,
  },
};
